module.exports = "/_next/static/images/img_list-5-b6a682acdbffd300eaa5f04377920a68.png";